<h2 mat-dialog-title class="version-dialog__title" id="version-dialog-title">About {{ appName }}</h2>

<mat-dialog-content class="version-dialog">
  <div class="version-dialog__brand">
    <img
      class="version-dialog__mark"
      [src]="sidebarLogoSrc"
      [appImgFallback]="sidebarLogoFallback"
      alt=""
    />
    <img
      class="version-dialog__wordmark"
      [src]="brandLogo"
      [style.max-width]="brandLogoWidth"
      alt=""
    />
  </div>

  <div class="version-dialog__divider" aria-hidden="true"></div>

  <dl class="version-dialog__meta">
    <div class="version-dialog__row">
      <dt class="version-dialog__label">Version</dt>
      <dd class="version-dialog__value version-dialog__value--version">
        <code>{{ version }}</code>
      </dd>
    </div>
    @if (canViewDeployInfo && frontendDeployVersion) {
      <div class="version-dialog__row">
        <dt class="version-dialog__label">Frontend deploy</dt>
        <dd class="version-dialog__value version-dialog__value--version">
          <code>{{ frontendDeployVersion.version }}</code>
          <span class="version-dialog__hint">
            {{ frontendDeployVersion.environment }} ·
            {{ formatBuiltAt(frontendDeployVersion.builtAt) }}
          </span>
        </dd>
      </div>
    }
    @if (canViewDeployInfo) {
      <div class="version-dialog__row">
        <dt class="version-dialog__label">Backend deploy</dt>
        <dd class="version-dialog__value version-dialog__value--version">
          @if (backendDeployVersion) {
            <code>{{ backendDeployVersion.version }}</code>
            <span class="version-dialog__hint">
              {{ backendDeployVersion.environment }}
              @if (backendDeployVersion.runtimeEnv) {
                ({{ backendDeployVersion.runtimeEnv }})
              }
              · {{ formatBuiltAt(backendDeployVersion.builtAt) }}
            </span>
          } @else if (backendDeployUnavailable) {
            <span class="version-dialog__hint">Unavailable</span>
          }
        </dd>
      </div>
    }
    <div class="version-dialog__row">
      <dt class="version-dialog__label">Copyright</dt>
      <dd class="version-dialog__value version-dialog__value--copyright">{{ copyright }}</dd>
    </div>
  </dl>
</mat-dialog-content>

<mat-dialog-actions align="end" class="version-dialog__actions">
  <button mat-button mat-dialog-close type="button">Close</button>
</mat-dialog-actions>
